<template>
  <!-- 运单签收 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="saveBtns"
        >确认签收</el-button
      >
    </div>
    <div class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInFormRef"
        label-width="130px"
        class="glo_formBox"
      >
        <!--  -->
        <el-form-item
          v-if="!isReceiveUserSign"
          label="签收人:"
          prop="signForName"
        >
          <el-input
            v-model="baseInForm.signForName"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isReceiveUserSign" label="签收人:" prop="">
          <el-input
            v-model="baseInForm.signForName"
            placeholder="默认收货人"
            clearable
          ></el-input>
        </el-form-item>
        <div style="margin-right: 20px">
          <el-checkbox
            style="height: 30px; line-height: 30px"
            v-model="isReceiveUserSign"
            label="isReceiveUserSign"
            name="type"
            >默认收货人</el-checkbox
          >
        </div>

        <el-form-item label="签收时间:" prop="signForTime">
          <el-date-picker
            v-model="baseInForm.signForTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="签收情况:" prop="signForSituation">
          <el-select v-model="baseInForm.signForSituation" placeholder="请选择">
            <el-option
              v-for="(item, index) in signForSituationList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="收货人身份证号:" prop="receiverIdcardNumber">
          <el-input
            v-model="baseInForm.receiverIdcardNumber"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="代理人身份证号:" prop="agentIdcardNumber">
          <el-input
            v-model="baseInForm.agentIdcardNumber"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="代理人手机:" prop="agentPhone">
          <el-input
            v-model="baseInForm.agentPhone"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item> -->

        <div style="width: 100%; display: flex">
          <el-checkbox-group class="checkBoxStyle" v-model="isRnOrderSure">
            <el-checkbox label="isRnOrderSure" name="type"
              >回单收回确认</el-checkbox
            >
          </el-checkbox-group>

          <el-checkbox-group class="checkBoxStyle" v-model="baseInForm.Sms">
            <el-checkbox label="isSenderSms" name="sendFa"
              >发送手机信息给发货人</el-checkbox
            >
            <el-checkbox label="isReceiverSms" name="sendShou"
              >发送手机信息给收货人</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <el-form-item
          label="收回部门:"
          prop="returnDeptId"
          v-if="isRnOrderSure.length > 0"
        >
          <el-select
            filterable
            clearable
            v-model="baseInForm.returnDeptId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in depList"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="收回人:"
          prop="returnUserId	"
          v-if="isRnOrderSure.length > 0"
        >
          <el-select
            filterable
            clearable
            v-model="baseInForm.returnUserId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in EmployeeList"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="remarks"
        >
          <el-input
            type="textarea"
            rows="3"
            v-model="baseInForm.remarks"
          ></el-input>
        </el-form-item>

        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">签收图片</div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="15"
            ></uploadimgs>
          </div>

          <div class="uploadItem" v-if="isRnOrderSure.length > 0">
            <div class="uploadLaber">回单图片</div>
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="6"
            ></uploadimgs>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 添加运单 -->
    <div class="formbox" style="padding-bottom: 0">
      <el-form
        :model="queryData"
        :rules="rules"
        label-width="130px"
        class="glo_formBox"
      >
        <div class="teSu">
          <el-form-item label="运单号:" prop="waybillNumber">
            <el-input
              v-model.trim="queryData.waybillNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-button class="glo_bgcMainColor formBtns" @click="getData"
            >查询并添加</el-button
          >
        </div>
      </el-form>
    </div>

    <div class="glo_Table" style="margin-bottom: 20px">
      <el-table
        header-align="center"
        ref="mytable"
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">
                {{ scope.row.waybillNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
              >
                {{ scope.row.waybillStatusShow }}
              </div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="80px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="delRows(scope.$index)"
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  components: { uploadimgs },
  data() {
    return {
      isRnOrderSure: [],
      isReceiveUserSign: true,
      baseInForm: {
        isReceiverSms: "",
        Sms: [],
        isSenderSms: "0",
        isRnOrderSure: "0",
        remarks: "",
        returnDeptId: "",
        returnUserId: "",
        rnOrderFileIds: [],
        signForFileIds: [],
        signForName: "",
        signForSituation: "",
        waybillNumbers: "",
        receiverIdcardNumber: "",
        agentIdcardNumber: "",
        agentPhone: "",
        signForTime: "",
      },
      fileNameLists: [],
      fileNameLists2: [],
      tableData: [],
      totalArr: [],
      rules: {
        signForName: [{ required: true, message: "请输入", trigger: "blur" }],
        signForSituation: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        signForTime: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      CustomerList: [],
      signForSituationList: [], //签收情况
      // 默认表头
      myTableHeard: [
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "原运单号",
          field: "mainWaybillNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拆单状态",
          field: "splitOrderStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "在途状态",
          field: "onwayStatusShow",
          width: "110",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货状态",
          field: "aaaaaa",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发状态",
          field: "outgoingStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务网点",
          field: "businessDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开单运费",
          field: "billingAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货省份",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货城市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货详细地址",
          field: "takeAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      queryData: {
        waybillNumber: "",
      },
      depList: [],
      EmployeeList: [],

      timers: "", //计时器
    };
  },
  watch: {
    //回单确认
    isRnOrderSure(a, b) {
      if (a.length > 0) {
      } else {
        this.baseInForm.returnDeptId = "";
        this.baseInForm.returnUserId = "";
      }
    },
  },
  created() {},
  mounted() {
    // 根据对象类型获取结算对象的下拉列表
    this.getObjectUserDownList("employee"); //获取员工列表
    this.getObjectUserDownList("dept"); //获取部门列表

    // 获取签收情况下拉列表
    this.$TOOLS
      .getStatusValList("bill_tms_waybill_sign_for_v3.sign_for_situation")
      .then((res) => {
        this.signForSituationList = res || [];
        if (this.signForSituationList.length > 0) {
          //默认正常签收
          this.baseInForm.signForSituation = "zheng_chang:sign_for_situation";
        }
      });

    this.baseInForm.signForTime = this.$TOOLS.getCurrentTime();
  },
  activated() {
    let datas = this.$route.query.datas || "";
    if (datas) {
      datas = JSON.parse(datas);
      console.log("datas", datas);
      this.tableData = datas;
    }

    let that = this;
    // this.timers = setInterval(() => {
    //   that.baseInForm.signForTime = that.$TOOLS.getCurrentTime();
    // }, 1000);
  },
  deactivated() {
    clearInterval(this.timers);
    this.timers = "";
  },
  destroyed() {},
  methods: {
    // 签收按钮
    saveBtns() {
      let pdata = JSON.parse(JSON.stringify(this.baseInForm));
      console.log(pdata);
      let isSenderSms = "0";
      let isReceiverSms = "0";
      let waybillNumbers = [];
      //发信息给收发货人 isHasTaskNoCompleteShow
      pdata.Sms.forEach((item) => {
        if (item == "isSenderSms") {
          isSenderSms = "1";
        }
        if (item == "isReceiverSms") {
          isReceiverSms = "1";
        }
      });

      // 处理图片
      let signForFileIds = [];
      let rnOrderFileIds = [];
      this.fileNameLists.forEach((item) => {
        // 签收图片
        signForFileIds.push(item.name);
      });
      this.fileNameLists2.forEach((item) => {
        // 回单图片
        rnOrderFileIds.push(item.name);
      });

      //
      let isHaseTask = false; //是否存在未完成任务, false==不存在
      let wayBillSignStr = ""; //未完成任务的运单
      for (var a = 0; a < this.tableData.length; a++) {
        let item = this.tableData[a];
        //提取运单号
        waybillNumbers.push(item.waybillNumber);

        if (item.isHasTaskNoComplete == 1) {
          isHaseTask = true;
          wayBillSignStr += item.waybillNumber + " ,";
        }
      }

      if (waybillNumbers.length == 0) {
        this.$message.warning("还没有选择需要签收的运单");
        return false;
      }

      let params = {
        isReceiverSms: isReceiverSms || "0",
        isRnOrderSure: this.isRnOrderSure.length > 0 ? "1" : "0",
        isReceiveUserSign: this.isReceiveUserSign ? "1" : "0", //默认收货人
        isSenderSms: isSenderSms || "0",
        remarks: pdata.remarks || "",
        returnDeptId: pdata.returnDeptId || "",
        returnUserId: pdata.returnUserId || "",
        rnOrderFileIds: rnOrderFileIds || [],
        signForFileIds: signForFileIds || [],
        signForName: pdata.signForName || "",
        signForSituation: pdata.signForSituation || "",
        agentIdcardNumber: pdata.agentIdcardNumber || "",
        agentPhone: pdata.agentPhone || "",
        receiverIdcardNumber: pdata.receiverIdcardNumber || "",
        signForTime: pdata.signForTime || "",
        waybillNumbers: waybillNumbers || [],
      };
      // 判断是否需存在未完成的任务
      if (isHaseTask) {
        this.$confirm(
          "所选运单中存在未完成的任务的任务,是否强制签收? 运单号: " +
            wayBillSignStr,
          "提示: ",
          {
            confirmButtonText: "强制签收",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            this.saveSignforWaybill(params);
          })
          .catch(() => {});
      } else {
        this.saveSignforWaybill(params);
      }
    },
    // 确认签收接口
    saveSignforWaybill(params) {
      this.$API.wtl_signforWaybill(params).then((res) => {
        this.$message.success(res.data.message || "签收成功");

        this.tableData = [];
        this.isRnOrderSure = [];
        this.fileNameLists = [];
        this.fileNameLists2 = [];
        this.baseInForm = {
          isReceiverSms: "",
          Sms: [],
          isSenderSms: "0",
          isRnOrderSure: "0",
          remarks: "",
          returnDeptId: "",
          returnUserId: "",
          rnOrderFileIds: [],
          signForFileIds: [],
          signForName: "",
          signForSituation: "",
          waybillNumbers: "",
        };
      });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 查询运单
    getData() {
      if (!this.queryData.waybillNumber) {
        this.$message.warning("请输入运单号");
        return false;
      }
      let param = {
        pageStart: 1,
        pageTotal: 100,
        // signforStatus: "wei_qina_shou",
        waybillNumberNoLike: this.queryData.waybillNumber,
      };

      this.$API.wtl_getWaybillList(param).then((res) => {
        let arrs = res.data.result.data || [];
        if (arrs.length > 0) {
          let row = arrs[0];
          if (row.waybillStatus == "yi_qian_shou:waybill_status") {
            this.$message.error("运单: " + row.waybillNumber + " 已签收");
            return false;
          }
          let ishas = false; //是否已经存在
          this.tableData.forEach((item) => {
            if (row.waybillSplitId == item.waybillSplitId) {
              if (row.waybillNumber !== this.queryData.waybillNumber) {
                this.$message.error("找不到对应的运单,确认运单是否已签收");
                return false;
              }
              ishas = true;
            }
          });
          if (ishas) {
            this.$message.error("该运单已存在");
          } else {
            this.tableData.push(row);
          }
        } else {
          this.$message.error("找不到对应的运单");
        }
      });
    },
    // 移除运单
    delRows(idx) {
      this.$confirm("确定移除该运单吗?", "提示:")
        .then((res) => {
          this.tableData.splice(idx, 1);
        })
        .catch();
    },
    // 跳转运单详情
    goYdDetails(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 33px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}
</style>